import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';

import { LoadingDataSpinner } from '../LoadingDataSpinner';
import { Cluster } from '../types/Cluster';
import { AddNewClusterButton } from './AddNewClusterButton';
import { DataConnectMultiClusterTableBody } from './DataConnectMultiClusterTableBody';
import { DataConnectMultiClusterTableHeaders } from './DataConnectMultiClusterTableHeaders';
import { DataConnectSharedClusterTableBody } from './DataConnectSharedClusterTableBody';
import { DataConnectSharedClusterTableHeaders } from './DataConnectSharedClusterTableHeaders';


export type DataConnectMultiClusterSectionProps = Readonly<{
  clusters: Record<string, Cluster>;
  sharedClusters: Record<string, Cluster>;
  allowCreateCluster: boolean;
  refreshPoolsAndClusters: () => void;
  hasLoadedPoolsAndClusters: boolean;
}>

export function DataConnectMultiClusterSection(props: DataConnectMultiClusterSectionProps) {
  const existingClusterNames = Object.values(props.clusters).map((cluster: Cluster) => cluster.displayName);
  const clusters: ReadonlyArray<Cluster> = Object.values(props.clusters);
  return (
    <div className={sectionExtraPaddingBottom}>
      <AddNewClusterButton
        existingClusterNames={existingClusterNames}
        refreshEdgePoolsAndClusters={props.refreshPoolsAndClusters}
        hasLoadedEdgePoolsAndClusters={props.hasLoadedPoolsAndClusters}
        allowCreateCluster={props.allowCreateCluster}
      />
      {!props.hasLoadedPoolsAndClusters && <>
        {LoadingDataSpinner()}
      </>}
      {(props.hasLoadedPoolsAndClusters && _.isEmpty(props.sharedClusters) && _.isEmpty(props.clusters)) && <>
        <div className={'tb-data-grid-cell-text tb-data-grid-DataConnect-center'}>
          <span>{Messages.dataConnectSiteSettingsClusterNotFoundWarning()}</span>
        </div>
      </>}

      {!_.isEmpty(props.clusters) && <>
        <table className={`${multiClusterTableStyle} tb-static-grid-table-cluster-pool-width`}>
            <DataConnectMultiClusterTableHeaders />
            <DataConnectMultiClusterTableBody
              clusters={props.clusters}
              existingClusterNames={existingClusterNames}
              refreshPoolsAndClusters={props.refreshPoolsAndClusters}
            />
        </table>
      </>}
      { !_.isEmpty(props.sharedClusters) && <>
      <div className={sharedClusterTableLabelStyle}>
          <span>
            {Messages.dataConnectSiteSettingsSharedClusters()}
          </span>
      </div>
      <table className={`${sharedClusterTableStyle} tb-static-grid-table-shared-cluster-width`}>
        <DataConnectSharedClusterTableHeaders />
        <DataConnectSharedClusterTableBody
          clusters={props.sharedClusters}
          hasLoadedPoolsAndClusters={props.hasLoadedPoolsAndClusters}
        />
      </table></>}
    </div>
  );
}

export const sectionExtraPaddingBottom = style({
  paddingBottom: TabStyles.Spacing.MediumSpace
});

export const multiClusterTableStyle = style({
  borderSpacing: 0,
  textAlign: 'left',
  backgroundColor: TabStyles.Colors.White,
  cursor: 'default',
  paddingTop: 10
});

export const sharedClusterTableStyle = style({
  borderSpacing: 0,
  textAlign: 'left',
  backgroundColor: TabStyles.Colors.White,
  cursor: 'default',
  paddingTop: 5
});


export const sharedClusterTableLabelStyle = style({
  paddingTop: 20,
  fontWeight: 700
});
